import type { SVGProps } from 'react';

const XlsIcon = (props: SVGProps<SVGSVGElement>) => (
   <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <path
         d="M3 3V29C3 30.6569 4.34315 32 6 32H26C27.6569 32 29 30.6569 29 29V12L17 0H6C4.34315 0 3 1.34315 3 3Z"
         fill="#5DC984"
      />
      <path d="M17 0L29 12H20C18.3431 12 17 10.6569 17 9V0Z" fill="#269C55" />
      <path
         d="M10.9072 20.332L11.8643 17.8906H13.5098L11.8398 21.416L13.5488 25H11.8838L10.9072 22.5146L9.93555 25H8.27051L9.97949 21.416L8.30469 17.8906H9.9502L10.9072 20.332ZM15.7119 23.8086H18.2314V25H14.2764V17.8906H15.7119V23.8086ZM22.0645 23.1348C22.0645 22.8451 21.9896 22.627 21.8398 22.4805C21.6934 22.3307 21.4248 22.1761 21.0342 22.0166C20.3213 21.7464 19.8086 21.4307 19.4961 21.0693C19.1836 20.7048 19.0273 20.2751 19.0273 19.7803C19.0273 19.1813 19.2389 18.7012 19.6621 18.3398C20.0885 17.9753 20.6289 17.793 21.2832 17.793C21.7194 17.793 22.1084 17.8857 22.4502 18.0713C22.792 18.2536 23.054 18.5124 23.2363 18.8477C23.4219 19.1829 23.5146 19.5638 23.5146 19.9902H22.084C22.084 19.6582 22.0124 19.4059 21.8691 19.2334C21.7292 19.0576 21.5257 18.9697 21.2588 18.9697C21.0081 18.9697 20.8128 19.0446 20.6729 19.1943C20.5329 19.3408 20.4629 19.5394 20.4629 19.79C20.4629 19.9854 20.541 20.1628 20.6973 20.3223C20.8535 20.4785 21.1302 20.6413 21.5273 20.8105C22.2207 21.0612 22.7236 21.3688 23.0361 21.7334C23.3519 22.098 23.5098 22.5618 23.5098 23.125C23.5098 23.7435 23.3128 24.2269 22.9189 24.5752C22.5251 24.9235 21.9896 25.0977 21.3125 25.0977C20.8535 25.0977 20.4352 25.0033 20.0576 24.8145C19.68 24.6257 19.3838 24.3555 19.1689 24.0039C18.9574 23.6523 18.8516 23.2373 18.8516 22.7588H20.292C20.292 23.1689 20.3717 23.4668 20.5312 23.6523C20.6908 23.8379 20.9512 23.9307 21.3125 23.9307C21.8138 23.9307 22.0645 23.6654 22.0645 23.1348Z"
         fill="white"
      />
   </svg>
);

export default XlsIcon;
